module.exports = __webpack_public_path__ + "img/DK36684828.31992eeb.png";